// GalleryPage.jsx
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./GalleryPage.css";
import { BASE_URL } from "../../config/baseUrl";

const GalleryPage = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    const lightbox = GLightbox({ selector: ".glightbox-gallery" });

    // Fetch all images from API
    fetch(`${BASE_URL}/gallery/list`)
      .then((res) => res.json())
      .then((data) => setImages(data))
      .catch((err) => console.error("Error fetching gallery images:", err));

    return () => lightbox.destroy();
  }, []);

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="event-hero d-flex align-items-center">
        <div className="container text-center">
          <h1>Gallery</h1>
          <p>Browse curated moments from our events, workshops, and branding.</p>
        </div>
      </section>

      {/* Gallery Section */}
      <main className="main gallery-page">
        <div className="container">
          <div className="row gy-4">
            {images.length > 0 ? (
              images.map((img, idx) => (
                <div key={idx} className="col-lg-4 col-md-6 col-sm-12">
                  <div className="portfolio-content h-100">
                    <a
                      href={img}
                      className="glightbox-gallery"
                      data-gallery="gallery-all"
                    >
                      <img
                        src={img}
                        className="img-fluid rounded object-fit-cover"
                        alt={`Gallery ${idx + 1}`}
                      />
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center">No images available yet.</p>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default GalleryPage;
